export const environment = {
    production: true,
    apiUrl: "",
    apiVersion: "1.0",
    groupName: "Klasse",
    groupsName: "",
    buildingName: "Schulhaus",
    buildingsName: "Schulhäuser",
    categories: "",
    children: "Kinder",
    firebase: {
        apiKey: "AIzaSyBExDlBV-bZBnSref0ydEw9m4OnecmElqs",
        authDomain: "schule-pratteln-k9sd63va.firebaseapp.com",
        databaseURL: "https://schule-pratteln-k9sd63va.firebaseio.com",
        projectId: "schule-pratteln-k9sd63va",
        storageBucket: "schule-pratteln-k9sd63va.appspot.com",
        messagingSenderId: "754750996493",
        appId: "1:754750996493:web:8c4adf9fd16a4a708c9544",
        measurementId: "G-FSRRL9WT4S"
    }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts